import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appThreeDigitDecimalNumber]",
})
export class ThreeDigitDecimalNumberDirective {
  private regex: RegExp = new RegExp(/^-?\d*\.?\d{0,3}$/g);

  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Del",
  ];

  constructor(private el: ElementRef) {}

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === "Decimal" || event.key === "." ? "." : event.key,
      current.slice(position),
    ].join("");

    // Prevent if it doesn't match the regex
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
